import { Transform, Type } from "class-transformer";
import { WarehouseDto } from "@/core/features/warehouses/warehouse.dto";
import { ConsumableDto } from "@/core/features/consumables/consumable.dto";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { toEuros } from "@/utils/numberUtils";
import { UserDto } from "@/core/features/users/user.dto";
import { parseApiDate } from "@/utils/dates/dateFormats";

export class WarehouseConsumableDto extends BaseEntityDto {
  @Type(() => WarehouseDto)
  warehouse: WarehouseDto;
  warehouseId: string;

  @Type(() => ConsumableDto)
  consumable: ConsumableDto;
  consumableId: string;

  @Transform(({ value }) => Number(value))
  stock: number;

  isStockAboveMinimum: boolean;

  @Transform(({ value }) => toEuros(value))
  averagePrice: number;

  @Transform(({ value }) => toEuros(value))
  totalCost = 0;

  get totalPrice(): number {
    return !this.stock || !this.averagePrice ? 0 : this.stock * this.averagePrice;
  }

  @Type(() => UserDto)
  verifiedBy: UserDto;
  verifiedById: string;

  @Transform(({ value }) => parseApiDate(value))
  verifiedAt: Date;
}
